import * as React from 'react';
import { useEffect, useState } from 'react';
import Button from '../../../common/form/Button';
import { matchLeases, LeaseUploadStats, LeaseMatchResult } from '../../../../api/Property';
import { LoadingDisplay } from '../../../common/LoadingOverlay';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import '../../../../styles/AdminPage.css';
import Modal from 'reactstrap/lib/Modal';
import * as moment from 'moment';
import LeaseMatchConfirmationTable from './LeaseMatchConfirmationTable';
import { userIsCompanyManageUser, userIsPropertyManageUser, userIsSystemManageUser } from './../../../../utilities/identity';

interface Props {
    propertyId: number;
    lastUpload?: LeaseUploadStats;
}

const LeaseMatchUploadWidget = (props: Props) => {
    const isUser = userIsCompanyManageUser() || userIsPropertyManageUser() || userIsSystemManageUser();
    const [file, setFile] = useState<File | undefined>(undefined);
    const [loading, setLoading] = useState(false);
    const [resultDisplay, setResultDisplay] = useState<string | undefined>(undefined);
    const [result, setResult] = useState<LeaseMatchResult[] | undefined>(undefined);
    const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
    const [lastUpload, setLastUpload] = useState<LeaseUploadStats | undefined>(props.lastUpload);


    useEffect(() => {
        setLastUpload(props.lastUpload);
    }, [props.lastUpload]);

    const submit = async () => {
        if (!file) {
            return;
        }
        const formData = new FormData();
        formData.append('file', file);

        setFile(undefined);
        setLoading(true);
        const response = await matchLeases(props.propertyId, formData);
        if (response.data !== undefined && !response.error) {
            setResult(response.data);
            setModalIsOpen(true);
        } else {
            setResultDisplay(`Match failed: ${response.error || 'unknown reason'}`);
        }

        setLoading(false);
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFile((e.target.files && e.target.files[0]) || undefined);
        setResultDisplay(undefined);
    };

    const fileInputId = 'file-input-element';

    return (
        <div className="lease-match-upload-widget">
            <h5>Prospect Application Data</h5>
            {loading ? (
                <LoadingDisplay />
            ) : (
                <>
                    <Row>
                        <Col xs={6}>
                            <input id={fileInputId} type="file" onChange={handleChange} disabled={isUser} />
                            <label
                                htmlFor={fileInputId}
                                className="btn btn-secondary font-weight-bold hovertip"
                            >
                                {file ? 'Change' : 'Choose'} File
                                <span className="hovertiptext">
                                    Uploaded file must be .csv with First Name, Last Name, and Email
                                    columns.
                                </span>
                            </label>
                        </Col>
                        <Col xs={6}>
                            {file && (
                                <Button
                                    text="Submit"
                                    onClick={submit}
                                    suppressBottomMargin={true}
                                    disabled={isUser}
                                />
                            )}
                        </Col>
                    </Row>
                    {lastUpload !== undefined && lastUpload !== null && (
                        <>
                            <div>
                                {`Last Upload: ${moment(lastUpload.date).format('M/D/YYYY')}`}
                            </div>
                            <div>
                                {`Exact Matches: ${lastUpload.exactMatches}, ` +
                                    `Borderline Matches: ${lastUpload.borderlineMatches}`}
                            </div>
                        </>
                    )}
                    {file && <div>Selected file: {`${file.name}`}</div>}
                    {resultDisplay && <div>{resultDisplay}</div>}
                    <Modal size="lg" isOpen={modalIsOpen}>
                        {result && (
                            <LeaseMatchConfirmationTable
                                result={result}
                                propertyId={props.propertyId}
                                setModalOpen={(open: boolean) => setModalIsOpen(open)}
                                setResultDisplay={(display: string) => setResultDisplay(display)}
                                setStatsDisplay={(stats: LeaseUploadStats) => setLastUpload(stats)}
                            />
                        )}
                    </Modal>
                </>
            )}
        </div>
    );
};

export default LeaseMatchUploadWidget;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/LeaseMatchUploadWidget.tsx